module.exports = __webpack_public_path__ + "img/plans.113b75a2.svg";